export default __webpack_public_path__ + "static/media/login.fa6f9ff5.png";